var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "TextArea"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.currentValue,
      expression: "currentValue"
    }],
    ref: 'text-area-' + _vm.textAreaId,
    staticClass: "TextArea-input",
    class: _vm.getTextAreaClasses,
    attrs: {
      "aria-label": _vm.label,
      "aria-required": _vm.isRequired,
      "autocomplete": _vm.getAutocomplete,
      "disabled": _vm.disabled,
      "id": 'js-text-area-' + _vm.textAreaId,
      "maxlength": _vm.maxLength,
      "readonly": _vm.readonly,
      "required": _vm.isRequired
    },
    domProps: {
      "value": _vm.currentValue
    },
    on: {
      "blur": function ($event) {
        return _vm.setFocused(false);
      },
      "focus": function ($event) {
        return _vm.setFocused(true);
      },
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value;
      }, _vm.stretchTextArea]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "TextArea-label"
  }, [_vm._v(" " + _vm._s(_vm.label) + " "), _vm.isRequired ? _c('span', {
    staticClass: "TextArea-required"
  }, [_vm._v(" * ")]) : _vm._e()]), _c('div', {
    ref: 'text-area-error-' + _vm.textAreaId,
    staticClass: "TextArea-error",
    class: {
      'TextArea-error--displayed': _vm.errorLabel !== ''
    },
    attrs: {
      "id": 'js-error-' + _vm.textAreaId,
      "aria-label": _vm.errorLabel,
      "tabindex": _vm.getErrorTabIndex
    }
  }, [_vm._v(" " + _vm._s(_vm.errorLabel) + " ")]), _c('transition', {
    attrs: {
      "name": "page",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.readonly && !_vm.isCurrentValueEmpty,
      expression: "!readonly && !isCurrentValueEmpty"
    }],
    staticClass: "TextArea-button",
    attrs: {
      "aria-label": _vm.$t('button.clear'),
      "tabindex": _vm.getTabIndexIcon,
      "type": "button"
    },
    on: {
      "click": _vm.clearInput
    }
  }, [_c('span', {
    staticClass: "TextArea-icon common-cross"
  })])]), _vm.showRemaining ? _c('div', {
    staticClass: "TextArea-remainingContainer"
  }, [_c('span', {
    staticClass: "TextArea-remaining"
  }, [_vm._v(_vm._s(_vm.getRemainingCharsLabel))])]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }